import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderV2 } from '@kotipizzagroup/kotipizza-orders-api-client';
import { LoadingButton } from '@mui/lab';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { StyledPaper, TitleRow } from '../../Styled/Styled';
import { downloadOrderReceiptPdf } from '../../../apis/orders-api';
import { useCustomSnackBar } from '../../SnackBar/useCustomSnackBar';

/**
 * What you can do with the order, as opposed to what it says. One card so the receipt download has
 * somewhere to belong other than the title, and somewhere for the next action to go.
 */
export const OrderActions: React.FC<{ order: OrderV2 }> = ({ order }) => {
  const { t } = useTranslation();
  const snackbar = useCustomSnackBar();
  const [isDownloadingOrderReceipt, setIsDownloadingOrderReceipt] = useState(false);

  const handleDownloadReceiptPdf = async () => {
    if (!order?.id) {
      return;
    }

    setIsDownloadingOrderReceipt(true);

    try {
      const fileResponse = await downloadOrderReceiptPdf(order.id);

      const blob: Blob = fileResponse.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileResponse.fileName ?? `Tilaus_${order.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      snackbar.showError(t('Could not download order receipt PDF'));
    } finally {
      setIsDownloadingOrderReceipt(false);
    }
  };

  return (
    <StyledPaper variant="outlined">
      <TitleRow>
        <h3>{t('Actions')}</h3>
      </TitleRow>
      <LoadingButton
        size="small"
        onClick={handleDownloadReceiptPdf}
        loading={isDownloadingOrderReceipt}
        variant="outlined"
        color="primary"
        startIcon={<FileDownloadIcon />}
      >
        {t('Download order receipt PDF')}
      </LoadingButton>
    </StyledPaper>
  );
};
